<template>
    <div id="workspace-photo-editor" class="workspace-module-container" ref="photoEditor"></div>
</template>

<script>
    import ImageEditor from 'tui-image-editor';
    import {urlForFileStorage} from "../common";
    import {bus} from "../../vue_bus";
    // import {blobToFile} from "../../tools";
    import {updatePhoto} from "../../httpConfig";

    export default {
        name: "WorkspacePhotoEditor",
        mixins: [urlForFileStorage],
        data() {
            return {
                updated: null,
                inDestroy: false
            }
        },
        async mounted() {
            if (this.$store.getters["IN_PROGRESS"])
                await this.$store.getters["IN_PROGRESS"];

            this.refresh_aspect_ratio_photos = (width, height) => {
                this.aspect_ratio_photos = (width / height);
            };

            this.fixAspectRatio = (width, height) => {
                let container = document.getElementById('workspace-photo-editor')
                let out = {
                    'height': height,
                    'width': width
                }
                if (width > height) {
                    if (width > container.offsetWidth) {
                        out['height'] = Math.round(height/(width/container.offsetWidth));
                        out['width'] = container.offsetWidth;
                    }
                    if (out['height'] > container.offsetHeight) {
                        out['width'] = Math.round(out['width']/(out['height']/container.offsetHeight));
                        out['height'] = container.offsetHeight;
                    }
                } if (width < height) {
                    if (height > container.offsetHeight) {
                        out['width'] = Math.round(width/(height/container.offsetHeight));
                        out['height'] = container.offsetHeight;
                    }
                    if (out['width'] > container.offsetWidth) {
                        out['height'] = Math.round(out['height']/(out['width']/container.offsetWidth));
                        out['width'] = container.offsetWidth;
                    }
                }
                return out
            }

            this.load_image = (image) => {
                this.imageEditor.loadImageFromURL(image, "canvas").then((result) => {
                    if (this.inDestroy)
                        return
                    let dimensions = this.fixAspectRatio(result.newWidth, result.newHeight)
                        this.imageEditor.resizeCanvasDimension({
                        "width": dimensions.width,
                        "height": dimensions.height
                    });
                    this.imageEditor.clearUndoStack()
                    this.imageEditor.clearRedoStack()
                });
            };

            this.rotate_image = (angle) => {
                this.imageEditor.startDrawingMode('CROPPER');
                this.imageEditor.rotate(angle).then(() => {
                    this.imageEditor.stopDrawingMode();
                    let dimensions = this.fixAspectRatio(
                        this.imageEditor._graphics._canvas.lowerCanvasEl.width,
                        this.imageEditor._graphics._canvas.lowerCanvasEl.height
                    )
                    this.imageEditor.resizeCanvasDimension({
                        "width": dimensions.width,
                        "height": dimensions.height
                    });
                    // this.refresh_aspect_ratio_photos(
                    //     this.imageEditor._graphics._canvas.lowerCanvasEl.width,
                    //     this.imageEditor._graphics._canvas.lowerCanvasEl.height);
                });
            };

            this.imageEditor = new ImageEditor(this.$refs.photoEditor, {
                cssMaxWidth: 100,
                cssMaxHeight: 100,
            });

            bus.$on("phe_click_crop", () => {
                this.imageEditor.startDrawingMode('CROPPER')
            });

            bus.$on("phe_click_rotate", (angle) => {
                this.rotate_image(angle);
                this.updated = {
                    photoID: this.$route.params.photoID,
                    projectUUID: this.$route.params.projectUUID
                }
            });

            bus.$on("phe_click_undo", (angle) => {
                this.imageEditor.undo();
            });

            bus.$on("phe_click_redo", (angle) => {
                this.imageEditor.redo();
            });

            bus.$on("phe_cancel_crop", () => {
                if (this.imageEditor.getDrawingMode() === 'CROPPER') {
                    this.imageEditor.stopDrawingMode();
                }
            })

            bus.$on("phe_save_changes", () => {
                this.saveChanges();
            })

            bus.$on("phe_cancel_changes", () => {
                this.load_image(this.activePhotoAbsoluteURL);
            })

            bus.$on("phe_click_apply", () => {
                this.imageEditor.crop(this.imageEditor.getCropzoneRect()).then(
                    (result) => {
                        this.imageEditor.stopDrawingMode();
                        this.updated = {
                            photoID: this.$route.params.photoID,
                            projectUUID: this.$route.params.projectUUID
                        }
                    }
                );
            });

            this.load_image(this.activePhotoAbsoluteURL)

            this.imageEditor.on('undoStackChanged', length => {
                this.$store.commit('photoEditorData/UNDO_STACK_LENGTH', length);
            })

            this.imageEditor.on('redoStackChanged', length => {
                this.$store.commit('photoEditorData/REDO_STACK_LENGTH', length);
            })
        },
        computed: {
            activePhotoAbsoluteURL() {
                let activePhoto = this.$store.getters[`active/GET_ACTIVE_PHOTO`]
                if (activePhoto) {
                    return this.urlForFileStorage(activePhoto.src);
                } else {
                    return undefined
                }
            }
        },
        watch: {
            async activePhotoAbsoluteURL(newPhoto) {
                // await this.saveChanges();
                if (!this.inDestroy)
                    this.load_image(newPhoto);

            }
        },
        async beforeDestroy() {
            this.inDestroy = true;
            await this.removeListeners();
            // await this.saveChanges();
        },
        destroyed() {
            this.imageEditor.destroy();
        },
        methods: {
            removeListeners() {
                let promise = new Promise((resolve) => {
                    bus.$off("phe_click_crop");
                    bus.$off("phe_click_rotate");
                    bus.$off("phe_click_undo");
                    bus.$off("phe_click_redo");
                    bus.$off("phe_cancel_crop");
                    bus.$off("phe_save_changes");
                    bus.$off("phe_cancel_changes");
                    bus.$off("phe_click_apply");
                    resolve();
                });
                if (this.$store.getters["IN_PROGRESS"])
                    this.$store.getters["IN_PROGRESS"].then(
                        ()=>{
                            this.$store.dispatch("IN_PROGRESS", promise);
                            return promise;
                        }
                    )
                this.$store.dispatch("IN_PROGRESS", promise);
                return promise;
            },

            async saveChanges() {
                if (!this.updated)
                    return null;

                if (this.updated.promise)
                    return this.updated.promise;

                if (this.$store.getters["IN_PROGRESS"])
                    await this.$store.getters["IN_PROGRESS"]

                this.updated.promise = new Promise((resolve, reject) => {
                    this.imageEditor._graphics._canvas.lowerCanvasEl.toBlob((blob) => {
                      updatePhoto({
                            file: blob,
                            projectUUID: this.updated.projectUUID,
                            photoID: this.updated.photoID
                        }).then(()=>{
                            this.updated = null
                            resolve();
                        }).catch((err) => {
                            reject(err)
                        });
                    })
                })
                this.$store.dispatch("IN_PROGRESS", this.updated.promise);
                return this.updated.promise;
            }
        }


    }
</script>

<style scoped>
    #workspace-photo-editor {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f2f2f2;
        user-select: none;
    }
</style>
